import { IPushRegistrationModel } from '@apps-common/types/portal/push-registration'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface IMyMonitoringNotificationsStore {
  hydrated: boolean
  setHydrated: (value: boolean) => void
  notificationsEnabled: boolean
  setNotificationsEnabled: (value: boolean) => void
  registration?: IPushRegistrationModel
  setRegistration: (registration?: IPushRegistrationModel) => void
  initRegistration: (value: boolean, registration?: IPushRegistrationModel) => void
  clearNotificationsEnabled: () => void
}

export const useMyMonitoringNotificationsStore = create<
  IMyMonitoringNotificationsStore,
  [['zustand/persist', unknown]]
>(
  persist(
    (set) => ({
      hydrated: false,
      setHydrated: (value) => set({ hydrated: value }),
      notificationsEnabled: false,
      setNotificationsEnabled: (notificationsEnabled) => set({ notificationsEnabled }),
      registration: undefined,
      setRegistration: (registration?: IPushRegistrationModel) => set({ registration }),
      initRegistration: (notificationsEnabled: boolean, registration?: IPushRegistrationModel) => set({ notificationsEnabled, registration }),
      clearNotificationsEnabled: () => set({ notificationsEnabled: false, registration: undefined })
    }),
    {
      name: 'mm-notifications-enabled',
      onRehydrateStorage: () => (state) => {
        state?.setHydrated(true)
      }
    }
  )
)
